import { render } from "./EditService.vue?vue&type=template&id=04646376&scoped=true"
import script from "./EditService.vue?vue&type=script&lang=js"
export * from "./EditService.vue?vue&type=script&lang=js"

import "./EditService.vue?vue&type=style&index=0&id=04646376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04646376"]])

export default __exports__